//import React, { useRef } from "react"; 
import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

export function MyContactForm() {
  const form = useRef(null);

  const [subject, setSubject] = useState("");
  const [squareMeters, setSquareMeters] = useState(0);
  const [movingDistance, setMovingDistance] = useState(0);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.init("ETOsZjath7hrHx4Q2");

    const formData = new FormData(form.current);

    const templateParams = {
      firstName: formData.get("firstName") || "",
      lastName: formData.get("lastName") || "",
      company: formData.get("company") || "",
      email: formData.get("email") || "",
      phone: formData.get("phone") || "",
      street: formData.get("street") || "",
      zipCode: formData.get("zipCode") || "",
      city: formData.get("city") || "",
      country: formData.get("country") || "",
      subject: formData.get("subject") || "",
      message: formData.get("message") || "",

      cleaningType: formData.get("cleaningType") || "",
      cleaningFrequency: formData.get("cleaningFrequency") || "",
      squareMeters: squareMeters || "",

      moveFrom: formData.get("moveFrom") || "",
      moveTo: formData.get("moveTo") || "",
      movingDistance: movingDistance || "",
      apartmentSize: formData.get("apartmentSize") || "",
      volume: formData.get("volume") || "",
      floorFrom: formData.get("floorFrom") || "",
floorTo: formData.get("floorTo") || "",
elevatorFrom: formData.get("elevatorFrom") || "",
elevatorTo: formData.get("elevatorTo") || "",

      pickupLocation: formData.get("pickupLocation") || "",
      deliveryLocation: formData.get("deliveryLocation") || "",
      transportItems: formData.get("transportItems") || "",

      clearingType: formData.get("clearingType") || "",
      clearingSize: formData.get("clearingSize") || "",
    };

    console.log("EMAIL PARAMS:", templateParams);

    emailjs
      .send("service_fsaf5ea", "template_xpo5ogq", templateParams)
      .then(
        (result) => {
          console.log(result.text);
          alert("Nachricht erfolgreich gesendet!");
        },
        (error) => {
          console.log(error.text);
          alert("Nachricht konnte nicht gesendet werden. Bitte später erneut versuchen.");
        }
      );
  };

  return (
    <div>
      <form
        ref={form}
        onSubmit={sendEmail}
        className="contact-form text-white fs-5 row g-3"
      >
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="firstName" className="form-label">
              Vorname
            </label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              name="firstName"
              placeholder="Vorname"
              required
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="lastName" className="form-label">
              Nachname
            </label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              name="lastName"
              placeholder="Nachname"
              required
            />
          </div>
        </div>

        <div className="col-md-12">
          <div className="mb-3">
            <label htmlFor="company" className="form-label">
              Firmenname
            </label>
            <input
              type="text"
              className="form-control"
              id="company"
              name="company"
              placeholder="Firmenname"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              E-Mail
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="E-Mail"
              required
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">
              Telefonnummer
            </label>
            <input
              type="tel"
              className="form-control"
              id="phone"
              name="phone"
              placeholder="Telefonnummer"
              required
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="street" className="form-label">
              Adresse
            </label>
            <input
              type="text"
              className="form-control"
              id="street"
              name="street"
              placeholder="Straße"
              required
            />
          </div>
        </div>

        <div className="col-md-2">
          <div className="mb-3">
            <label htmlFor="zipCode" className="form-label">
              Postleitzahl
            </label>
            <input
              type="text"
              className="form-control"
              id="zipCode"
              name="zipCode"
              placeholder="PLZ"
              required
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="city" className="form-label">
              Stadt
            </label>
            <input
              type="text"
              className="form-control"
              id="city"
              name="city"
              placeholder="Stadt"
              required
            />
          </div>
        </div>

        <div className="col-md-12">
          <div className="mb-3">
            <label htmlFor="country" className="form-label">
              Land
            </label>
            <input
              type="text"
              className="form-control"
              id="country"
              name="country"
              placeholder="Land"
              required
            />
          </div>
        </div>

        <div className="col-md-12">
          <label htmlFor="inputState" className="form-label">
            Bereich
          </label>
          <select
            id="inputState"
            className="form-select"
            name="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          >
            <option value="">Bitte wählen...</option>
            <option value="umzug">Umzug</option>
            <option value="reinigung">Reinigung</option>
            <option value="transport">Transport</option>
            <option value="entruempelung">Entrümpelung</option>
          </select>
        </div>

        {subject === "umzug" && (
          <>
            <div className="col-md-6">
              <label htmlFor="moveFrom" className="form-label">
                Von
              </label>
              <input
                type="text"
                className="form-control"
                id="moveFrom"
                name="moveFrom"
                placeholder="Startadresse"
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="moveTo" className="form-label">
                Nach
              </label>
              <input
                type="text"
                className="form-control"
                id="moveTo"
                name="moveTo"
                placeholder="Zieladresse"
                required
              />
            </div>

            <div className="col-md-12">
              <label htmlFor="movingDistance" className="form-label">
                Entfernung: {movingDistance} km
              </label>
              <input
                type="range"
                className="form-range"
                id="movingDistance"
                min="0"
                max="1000"
                step="5"
                value={movingDistance}
                onChange={(e) => setMovingDistance(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="apartmentSize" className="form-label">
                Wohnungsgröße
              </label>
              <select
                id="apartmentSize"
                name="apartmentSize"
                className="form-select"
              >
                <option value="">Bitte wählen...</option>
                <option value="1-zimmer">1 Zimmer</option>
                <option value="2-zimmer">2 Zimmer</option>
                <option value="3-zimmer">3 Zimmer</option>
                <option value="4-zimmer">4 Zimmer</option>
                <option value="5-zimmer">5+ Zimmer</option>
              </select>
            </div>

            <div className="col-md-6">
              <label htmlFor="volume" className="form-label">
                Volumen (m³)
              </label>
              <input
                type="number"
                className="form-control"
                id="volume"
                name="volume"
                min="0"
                placeholder="z. B. 20"
              />
            </div>

            <div className="col-md-3">
  <label htmlFor="floorFrom" className="form-label">
    Etage (Abholort)
  </label>
  <input
    type="number"
    className="form-control"
    id="floorFrom"
    name="floorFrom"
    min="0"
    placeholder="z. B. 3"
  />
</div>

<div className="col-md-3">
  <label htmlFor="floorTo" className="form-label">
    Etage (Zielort)
  </label>
  <input
    type="number"
    className="form-control"
    id="floorTo"
    name="floorTo"
    min="0"
    placeholder="z. B. 1"
  />
</div>

<div className="col-md-3">
  <label htmlFor="elevatorFrom" className="form-label">
    Aufzug (Abholort)
  </label>
  <select
    id="elevatorFrom"
    name="elevatorFrom"
    className="form-select"
  >
    <option value="">Bitte wählen...</option>
    <option value="ja">Ja</option>
    <option value="nein">Nein</option>
  </select>
</div>

<div className="col-md-3">
  <label htmlFor="elevatorTo" className="form-label">
    Aufzug (Zielort)
  </label>
  <select
    id="elevatorTo"
    name="elevatorTo"
    className="form-select"
  >
    <option value="">Bitte wählen...</option>
    <option value="ja">Ja</option>
    <option value="nein">Nein</option>
  </select>
</div>
</>
        )}

        {subject === "transport" && (
          <>
            <div className="col-md-6">
              <label htmlFor="pickupLocation" className="form-label">
                Abholort
              </label>
              <input
                type="text"
                className="form-control"
                id="pickupLocation"
                name="pickupLocation"
                placeholder="Abholadresse"
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="deliveryLocation" className="form-label">
                Zielort
              </label>
              <input
                type="text"
                className="form-control"
                id="deliveryLocation"
                name="deliveryLocation"
                placeholder="Zieladresse"
                required
              />
            </div>

            <div className="col-md-12">
              <label htmlFor="movingDistanceTransport" className="form-label">
                Entfernung: {movingDistance} km
              </label>
              <input
                type="range"
                className="form-range"
                id="movingDistanceTransport"
                min="0"
                max="1000"
                step="5"
                value={movingDistance}
                onChange={(e) => setMovingDistance(e.target.value)}
              />
            </div>

            <div className="col-md-12">
              <label htmlFor="transportItems" className="form-label">
                Was soll transportiert werden?
              </label>
              <input
                type="text"
                className="form-control"
                id="transportItems"
                name="transportItems"
                placeholder="z. B. Möbel, Geräte, Kartons"
              />
            </div>
          </>
        )}

        {subject === "reinigung" && (
          <>
            <div className="col-md-6">
              <label htmlFor="cleaningType" className="form-label">
                Reinigungsart
              </label>
              <select
                id="cleaningType"
                name="cleaningType"
                className="form-select"
                required
              >
                <option value="">Bitte wählen...</option>
                <option value="privatwohnung">Privatwohnung</option>
                <option value="gewerbe">Gewerbe</option>
                <option value="buero">Büro</option>
                <option value="praxis">Praxis</option>
                <option value="treppenhaus">Treppenhaus</option>
                <option value="endreinigung">Endreinigung</option>
              </select>
            </div>

            <div className="col-md-6">
              <label htmlFor="cleaningFrequency" className="form-label">
                Häufigkeit
              </label>
              <select
                id="cleaningFrequency"
                name="cleaningFrequency"
                className="form-select"
              >
                <option value="">Bitte wählen...</option>
                <option value="einmalig">Einmalig</option>
                <option value="woechentlich">Wöchentlich</option>
                <option value="zweiwoechentlich">14-tägig</option>
                <option value="monatlich">Monatlich</option>
              </select>
            </div>

            <div className="col-md-12">
              <label htmlFor="squareMeters" className="form-label">
                Quadratmeter: {squareMeters} m²
              </label>
              <input
                type="range"
                className="form-range"
                id="squareMeters"
                min="0"
                max="4000"
                step="1"
                value={squareMeters}
                onChange={(e) => setSquareMeters(e.target.value)}
              />
            </div>
          </>
        )}

        {subject === "entruempelung" && (
          <>
            <div className="col-md-6">
              <label htmlFor="clearingType" className="form-label">
                Objektart
              </label>
              <select
                id="clearingType"
                name="clearingType"
                className="form-select"
              >
                <option value="">Bitte wählen...</option>
                <option value="wohnung">Wohnung</option>
                <option value="haus">Haus</option>
                <option value="keller">Keller</option>
                <option value="garage">Garage</option>
                <option value="buero">Büro</option>
              </select>
            </div>

            <div className="col-md-6">
              <label htmlFor="clearingSize" className="form-label">
                Fläche in m²
              </label>
              <input
                type="number"
                className="form-control"
                id="clearingSize"
                name="clearingSize"
                min="0"
                placeholder="z. B. 85"
              />
            </div>
          </>
        )}

        <div className="col-md-12">
          <div className="mb-3">
            <label htmlFor="message" className="form-label">
              Nachricht
            </label>
            <textarea
              className="form-control"
              id="message"
              name="message"
              rows="4"
              placeholder="Beschreiben Sie kurz Ihr Anliegen"
            ></textarea>
          </div>
        </div>

        <div className="col-md-12">
          <button type="submit" className="btn btn-primary">
            Senden
          </button>
        </div>
      </form>
    </div>
  );
}
